import React from 'react'
export default class FileUpload extends React.Component {
  render () {
    return "文件上传"
  }
}
